const usuarios=[
    {
        idUsu:"001",
        estado:"Habilitado",
        correo:"david.munevar@sistemasgyg.com.co",
        celular:"3228743680",
        perfil:"SuperAdmin",
        horaUltIng:"11:25",
        FechaUltIng:"26/08/2021",

    },
    {
        idUsu:"002",
        estado:"Habilitado",
        correo:"jesus.rios@sistemasgyg.com.co",
        celular:"3106290109",
        perfil:"SuperAdmin",
        horaUltIng:"09:25",
        FechaUltIng:"26/08/2021",

    }
];

module.exports=usuarios;